// @generated by tools/docgen — do not edit.
// Source: docs/examples/index.md

import React from 'react';

export function ExamplesPage() {
  return (
    <div className="mx-auto w-full max-w-3xl flex-1 overflow-y-auto px-6 py-10">
      <h1 className="text-2xl font-semibold tracking-tight text-ink">
        Examples
      </h1>
      <p className="mt-4 max-w-prose text-base leading-relaxed text-primary-800">
        Each example is a small, complete Django app with a live demo: read the real source on the left, interact with the running widget on the right. They build on each other, from a single reactive value to live, server-routed lists.
      </p>
      <ul className="mt-6 flex flex-col gap-2">
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/counter`} className="text-primary-700 hover:underline">
            Basic channel
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/carousel`} className="text-primary-700 hover:underline">
            rx fields
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/memo`} className="text-primary-700 hover:underline">
            @memo
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/simple_model`} className="text-primary-700 hover:underline">
            Simple model
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/nested_model`} className="text-primary-700 hover:underline">
            Nested model
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/reactive_model`} className="text-primary-700 hover:underline">
            Reactive model
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/authorization`} className="text-primary-700 hover:underline">
            Authorization
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/authorization_meta`} className="text-primary-700 hover:underline">
            Authorization Meta
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/scalar_list`} className="text-primary-700 hover:underline">
            Reactive list of scalars
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/list_types`} className="text-primary-700 hover:underline">
            Union and optional list elements
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/streaming_list`} className="text-primary-700 hover:underline">
            Streaming list updates
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/static_queryset`} className="text-primary-700 hover:underline">
            Static queryset
          </a>
        </li>
        <li>
          <a href={`${process.env.PUBLIC_URL || ''}/examples/task_board`} className="text-primary-700 hover:underline">
            Task board
          </a>
        </li>
      </ul>
    </div>
  );
}

export default ExamplesPage;
